import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { CircleIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root ref={ref} data-slot='radio-group' className={cn('grid gap-3', className)} {...props} />;
});

RadioGroup.displayName = 'RadioGroup';

function RadioGroupItem({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>): JSX.Element {
  return (
    <RadioGroupPrimitive.Item
      data-slot='radio-group-item'
      className={cn(
        'border-ring text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-testid='radio-group-item-indicator'
        data-slot='radio-group-indicator'
        className='relative flex items-center justify-center'
      >
        <CircleIcon
          data-testid='radio-group-item-indicator-icon'
          className='fill-primary absolute top-1/2 left-1/2 size-3 -translate-x-1/2 -translate-y-1/2'
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
